/** Demo Mode only - shared types for the consolidated Finance area (see
 * src/mocks/data/financeData.ts for the underlying dataset and reconciliation guarantees). */

import { CommercialModel, ContractSector, FinanceScenario } from '../../mocks/data/financeData';

export enum FinanceTab {
  Overview = 'overview',
  Forecast = 'forecast',
  ProfitAndLoss = 'profit-and-loss',
  Contracts = 'contracts',
  EbitAnalysis = 'ebit-analysis',
}

export type ScopeLevel = 'company' | 'client' | 'contract' | 'site';

export type FinanceView = 'ytd' | 'fullYear';

/** Comparison basis selectable in the shared filter bar - drives which scenario is shown
 * alongside "Current forecast" wherever a page shows a single comparison column/line. */
export type ComparisonBasis = Exclude<FinanceScenario, 'currentForecast'>;

export interface FinanceFilterState {
  scopeLevel: ScopeLevel;
  scopeId: string;
  view: FinanceView;
  comparison: ComparisonBasis;
  sector: ContractSector | '';
  region: string | '';
  commercialModel: CommercialModel | '';
}
